var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#2b2d4a;}.a{stroke:#707070;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(-3788 -1842)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(3788 1842)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3787 -1842)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.646,3.133v.2a15.162,15.162,0,0,1-.12,2.049l-.063.3a2.159,2.159,0,0,1-.13.435,1.008,1.008,0,0,1-.89.551H4.412a2.8,2.8,0,0,1-.746-.226A12.58,12.58,0,0,1,.559,4.335l-.211-.22a1.99,1.99,0,0,1-.156-.186A.982.982,0,0,1,0,3.338a1.031,1.031,0,0,1,.208-.632l.216-.234.048-.05A12.263,12.263,0,0,1,3.746.187L3.882.135A2.25,2.25,0,0,1,4.412,0a1.111,1.111,0,0,1,.505.122,1.048,1.048,0,0,1,.449.5,5.439,5.439,0,0,1,.145.591A12.379,12.379,0,0,1,5.646,3.133Zm4.354.2a.839.839,0,0,1-.835.843L7.11,4a.662.662,0,0,1,0-1.323L9.165,2.49A.839.839,0,0,1,10,3.334Z",
    transform: "translate(0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.e144b5fbf8ff8d2f2b95096cddc4626f.svg";
export { ForwardRef as ReactComponent };